import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateAbExperiments } from '../../store/reducers/abData';
import { isProduction } from '../../helpers';
import { LOCAL_STORAGE_DEV_AB_EXPERIMENTS } from '../../constants';
import { localStorage } from '../../helpers/storage';

type ExperimentsStorageItem = Record<string, string>;

export const useDevAbExperiments = () => {
    const isDevelopment = !isProduction;
    const dispatch = useDispatch();

    const loadDevExperimentFromLocal = (): ExperimentsStorageItem | null => {
        try {
            const customExperiments = localStorage.getItem(LOCAL_STORAGE_DEV_AB_EXPERIMENTS);
            if (!customExperiments) {
                return null;
            }
            return JSON.parse(customExperiments) as ExperimentsStorageItem;
        } catch (e) {
            return null;
        }
    };

    const saveDevExperimentsLocal = (name: string, value: string) => {
        const newExperiments = {
            ...loadDevExperimentFromLocal(),
            [name]: value,
        };
        localStorage.setItem(LOCAL_STORAGE_DEV_AB_EXPERIMENTS, JSON.stringify(newExperiments));
    };

    const setDevExperiments = () => {
        const devExperiments = loadDevExperimentFromLocal();
        if (!devExperiments) {
            return;
        }
        dispatch(updateAbExperiments(devExperiments));
    };

    useEffect(() => {
        if (isDevelopment) {
            setDevExperiments();

            (window as any).setDevAbExperiment = (name: unknown, value: unknown) => {
                if (typeof name !== 'string' || typeof value !== 'string' || !name || !value) {
                    return;
                }
                dispatch(updateAbExperiments({ [name]: value }));
                saveDevExperimentsLocal(name, value);
            };
            (window as any).clearDevAbExperiments = () => {
                localStorage.removeItem(LOCAL_STORAGE_DEV_AB_EXPERIMENTS);
            };
        }
    }, []);
};
